export enum AddStudentColumnsEnum {
  STUDENT_NAME = 'Student Name',
  STUDENT_ID = 'Student ID',
  GRADE = 'Grade',
  ACTION = 'Action'
}
